<template lang="">
  <div>
    <div>
      <div class="pa-4 d-flex justify-space-between align-center">
        <div>
          <Breadcrumbs
            headline="Nhóm khoản phí"
            :link="[
              { text: 'Nâng cao', href: '/tuition-headFee-Groups', disabled: false },
              { text: 'Nhóm khoản phí', href: '/tuition-headFee-Groups', disabled: false }
            ]"
          />
        </div>
        <v-spacer></v-spacer>
        <div class="d-flex align-end">
          <v-btn class="ml-6" depressed color="primary" @click="$refs.collectionTable.openDialog()">
            <v-icon left>add</v-icon>
            Thêm nhóm
          </v-btn>
        </div>
      </div>
      <v-card outlined class="mx-4 elevation-0" md>
        <TuitionCollectionTable />
      </v-card>

      <CollectionNewDialog style="margin: 0 20px" ref="collectionTable"></CollectionNewDialog>
    </div>
  </div>
</template>
<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import TuitionCollectionTable from '@/modules/tuitionFee/tuition-collection/TuitionCollectionTable.vue'
import CollectionNewDialog from '@/modules/tuitionFee/tuition-collection/CollectionNewDialog.vue'

export default {
  components: {
    Breadcrumbs,
    TuitionCollectionTable,
    CollectionNewDialog
  }
}
</script>
<style lang=""></style>
